import dotProp from 'dot-prop-immutable'

import * as actions from '../actionTypes'
import { PER_PAGE } from '../constants'

const initialState = {
  viewFiltersStatus: false,
  activeProjects: [],
  filters: {
    attending: {
      available: [],
      selected: [],
    },
    department: {
      available: [],
      selected: [],
    },
    positionType: {
      available: [],
      selected: [],
    },
    division: {
      available: [],
      selected: [],
    },
  },
  isLoading: false,
  pagination: {
    pageNumber: 1,
    pageSize: null,
    perPage: PER_PAGE,
    totalPages: 0,
    totalResults: 0,
  },
  sortBy: '',
}

const projectBoardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST:
      return dotProp.set(state, 'isLoading', true)
    case actions.PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST_FAILURE:
      return dotProp.set(state, 'isLoading', false)
    case actions.PROJECT_BOARD_ACTIVE_PROJECTS_REQUEST_SUCCESS: {
      const { activeProjects, pageNumber, pageSize, totalPages, totalResults } = action.payload
      state = dotProp.set(state, 'activeProjects', activeProjects)
      state = dotProp.set(state, 'isLoading', false)
      return dotProp.merge(state, 'pagination', {
        pageNumber,
        pageSize,
        totalPages,
        totalResults,
      })
    }
    case actions.PROJECT_BOARD_SET_SORT_BY:
      return dotProp.set(state, 'sortBy', action.payload.sortBy)
    case actions.FILTER_REQUEST_SUCCESS: {
      const { attendings, departments, positions, divisions } = action.payload
      state = dotProp.set(state, 'filters.positionType.available', positions)
      state = dotProp.set(state, 'filters.attending.available', attendings)
      state = dotProp.set(state, 'filters.department.available', departments)
      return dotProp.set(state, 'filters.division.available', divisions)
    }
    case actions.FILTER_SELECTION_REQUEST: {
      const { category, filter } = action.payload
      const selected = state.filters[category].selected
      const filterIndex = selected.indexOf(filter)
      return filterIndex > -1
        ? dotProp.delete(state, `filters.${category}.selected.${filterIndex}`)
        : dotProp.merge(state, `filters.${category}.selected`, [filter])
    }
    case actions.FILTER_SELECTION_REQUEST_ALL: {
      const { category } = action.payload
      const arrayAll = state.filters[category].available
      return dotProp.set(state, `filters.${category}.selected`, arrayAll)
    }
    case actions.FILTER_DESELECTION_REQUEST_ALL: {
      const { category } = action.payload
      return dotProp.set(state, `filters.${category}.selected`, [])
    }
    case actions.FILTER_SELECTION_REQUEST_ALL_DESELECT: {
      state = dotProp.set(state, 'filters.positionType.selected', [])
      state = dotProp.set(state, 'filters.attending.selected', [])
      state = dotProp.set(state, 'filters.department.selected', [])
      return dotProp.set(state, 'filters.division.selected', [])
    }
    case actions.RESET_REDUX: {
      return initialState
    }
    case actions.VIEW_FILTERS_MOBILE: {
      return dotProp.set(state, 'viewFiltersStatus', true)
    }
    case actions.HIDE_FILTERS_MOBILE: {
      return dotProp.set(state, 'viewFiltersStatus', false)
    }
    default:
      return state
  }
}

export default projectBoardReducer
